export default __webpack_public_path__ + "static/media/Suryakanta Mohapatra.88219920.JPG";